/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

const ChevronDownIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    (<svg
      className={props.className}
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      data-palette="ChevronDownIcon">
      <g id="THE-END" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Wallet-balance"
          transform="translate(-1281.000000, -52.000000)"
          fillRule="nonzero"
        >
          <g id="Group-13" transform="translate(1281.000000, 52.000000)">
            <rect
              className="rect"
              fill="#A6A9AD"
              x="0"
              y="0"
              width="16"
              height="16"
              rx="8"
            />
            <g
              id="Group-47-Copy"
              transform="translate(8.428571, 7.571429) scale(1, -1) translate(-8.428571, -7.571429) translate(3.428571, 2.571429)"
            >
              <rect
                id="Rectangle-39"
                x="0"
                y="0"
                width="9.14285714"
                height="9.14285714"
              />
              <polygon
                id="Shape"
                fillOpacity="0.9"
                fill="#F7F8FA"
                points="0.144 6.63428571 9.00114286 6.63428571 4.57142857 0.506285714"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export default ChevronDownIcon;
